import React from 'react'
import { FloatingInspectorButton, FloatingInspectorButtonProps } from '../FloatingInspectorButton'
import FloatingInspectorCircleRenderer from '../SharedComponents/FloatingInspectorCircleRenderer'

export interface FloatingInspectorButtonImageInCircleProps
  extends Pick<
    FloatingInspectorButtonProps,
    | 'onClick'
    | 'selected'
    | 'disabled'
    | 'tooltipText'
    | 'placementTooltip'
    | 'marginTooltip'
    | 'popoverContent'
  > {
  src?: string
  backgroundColor?: string | 'transparent' // Color value like '#fff', '#000'
}

type OnlySrc = { src: string; backgroundColor?: never }
type OnlyBackgroundColor = { backgroundColor: string; src?: never }
export type StrictImageInCircleProps = (OnlySrc | OnlyBackgroundColor) &
  Pick<FloatingInspectorButtonProps, 'onClick' | 'selected' | 'disabled'>

const FloatingInspectorButtonImageInCircle: React.FC<FloatingInspectorButtonImageInCircleProps> = ({
  src,
  backgroundColor,
  onClick,
  selected,
  disabled,
  tooltipText,
  placementTooltip,
  marginTooltip,
  popoverContent,
}) => (
  <FloatingInspectorButton
    onClick={onClick}
    selected={selected}
    disabled={disabled}
    tooltipText={tooltipText}
    placementTooltip={placementTooltip}
    marginTooltip={marginTooltip}
    popoverContent={popoverContent}
  >
    <FloatingInspectorCircleRenderer src={src} backgroundColor={backgroundColor} />
  </FloatingInspectorButton>
)

export default FloatingInspectorButtonImageInCircle
